import { postLogout } from '@/api/auth/authApi';
import { createMutationHook } from '@/lib/adapters/react-query-adapter';

export const useLogout = createMutationHook<void, void, Error>(() => postLogout());
